import React from "react";

interface StringBadgeCellProps {
  value: { stringText: string; badgeText: string };
  [key: string]: unknown;
}

/**
 * Renders a primary string with a grey badge beneath it (subtext).
 * Matches the delivery / DOW column pattern of date + batch badge.
 *
 * @param value - Cell value with `stringText` and `badgeText`
 * @returns Stacked string + badge markup
 */
export const StringBadgeCell: React.FC<StringBadgeCellProps> = ({ value }) => {
  return (
    <div className="flex w-full flex-col gap-1">
      <div title={value.stringText}>{value.stringText}</div>
      {value.badgeText !== "" && (
        <div
          className="table-cell-string-badge"
          style={{
            color: "#0F0F0F",
            backgroundColor: "#F5F5F5",
          }}
          title={value.badgeText}
        >
          {value.badgeText}
        </div>
      )}
    </div>
  );
};

export default StringBadgeCell;
